import { api, formatApiError } from './api';

export const FREQUENCY_DEFAULT_TIMES = {
  'once daily': ['08:00'],
  'twice daily': ['08:00', '20:00'],
  'three times daily': ['08:00', '14:00', '20:00'],
  'four times daily': ['08:00', '12:00', '16:00', '20:00'],
  'as needed': [],
  custom: [],
};

export function defaultTimesForFrequency(frequency) {
  return FREQUENCY_DEFAULT_TIMES[frequency.trim().toLowerCase()] ?? [];
}

export function resolveDeviceTimezone() {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC';
  } catch {
    return 'UTC';
  }
}

export function formatLocalTime(iso, tz) {
  try {
    const d = new Date(iso);
    return new Intl.DateTimeFormat(undefined, {
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
      timeZone: tz,
    }).format(d);
  } catch {
    return iso;
  }
}

export async function getToday(tz) {
  try {
    const { data } = await api.get('/doses/today', { params: { tz } });
    return data;
  } catch (err) {
    throw new Error(formatApiError(err));
  }
}

export async function getUpcoming(hours, tz) {
  try {
    const { data } = await api.get('/doses/upcoming', { params: { hours, tz } });
    return data;
  } catch (err) {
    throw new Error(formatApiError(err));
  }
}

export async function markDose(medication_id, scheduled_for, status) {
  try {
    const { data } = await api.post('/doses/mark', { medication_id, scheduled_for, status });
    return data;
  } catch (err) {
    throw new Error(formatApiError(err));
  }
}

export async function getAdherence(days, tz) {
  try {
    const { data } = await api.get('/doses/adherence', { params: { days, tz } });
    return data;
  } catch (err) {
    throw new Error(formatApiError(err));
  }
}

export async function getDoseHistory(days, tz) {
  try {
    const { data } = await api.get('/doses/history', { params: { days, tz } });
    return data;
  } catch (err) {
    throw new Error(formatApiError(err));
  }
}
